import PropTypes from 'prop-types'
import styles from './Radio.module.css'

export function Radio({
  checked = false,
  onChange,
  disabled = false,
  id,
  name,
  required = false,
  label,
  className = '',
}) {
  const iconName = checked ? 'radio_button_checked' : 'radio_button_unchecked'

  return (
    <label className={[styles.radio, className].filter(Boolean).join(' ')}>
      <input
        className={styles.radio__input}
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
      />
      <span className={`${styles.radio__icon} material-icons-outlined`}>{iconName}</span>
      {label && <span className={styles.radio__label}>{label}</span>}
    </label>
  )
}

Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
}
